__webpack_require__.p = "/issues/42/aperturescience-com/";